export default __webpack_public_path__ + "static/media/congratulation.86ee70b8.svg";